
import { Menu } from 'floating-vue'
import { defineComponent, PropType } from 'vue'

import { AgentStatus } from '~/types/types'

export interface StatusConfig {
  label: string
  icon: {
    icon: string
    color?: string
  }
  status: AgentStatus
}

const STATUSES: StatusConfig[] = [
  {
    label: 'Paused',
    icon: {
      icon: 'pause-circle',
      color: 'amber'
    },
    status: AgentStatus.Paused
  },
  {
    label: 'Offline',
    icon: {
      icon: 'stop-circle',
      color: 'cherry'
    },
    status: AgentStatus.Disabled
  },
  {
    label: 'Online',
    icon: {
      icon: 'circle-solid',
      color: 'juniper'
    },
    status: AgentStatus.Enabled
  }
]

export default defineComponent({
  name: 'AgentStatus',
  components: {
    // eslint-disable-next-line vue/no-reserved-component-names
    Menu
  },
  props: {
    status: {
      type: String as PropType<AgentStatus> | null,
      required: true
    }
  },
  computed: {
    computedStatus: {
      get() {
        return STATUSES.find((status) => status.status === this.status) ?? STATUSES[0]
      },
      set(value: StatusConfig) {
        this.$emit('update:status', value.status)
      }
    },
    computedStatuses() {
      return STATUSES.filter((status) => status.status !== this.status)
    }
  }
})
